/**
 * Splitter — Gegenstück zu CanMonitorApp::OnMainSplitterDrag()/
 * IsPointInMainSplitter(). Meldet das Verhältnis der oberen (bzw. linken)
 * Fläche als Bruch zwischen 0 und 1.
 */

export interface SplitterOptions {
  orientation?: 'horizontal' | 'vertical';
  /** Mindestanteil je Seite, verhindert das Zuklappen einer Fläche. */
  minRatio?: number;
  onRatioChanged: (ratio: number) => void;
}

export function createSplitter(container: HTMLElement, options: SplitterOptions): HTMLDivElement {
  const orientation = options.orientation ?? 'horizontal';
  const minRatio = options.minRatio ?? 0.1;

  const splitter = document.createElement('div');
  splitter.className = `cm-splitter cm-splitter--${orientation}`;
  splitter.setAttribute('role', 'separator');

  splitter.addEventListener('pointerdown', (event: PointerEvent) => {
    event.preventDefault();
    splitter.classList.add('cm-splitter--dragging');

    const onMove = (moveEvent: PointerEvent): void => {
      const rect = container.getBoundingClientRect();
      const raw =
        orientation === 'horizontal'
          ? (moveEvent.clientY - rect.top) / rect.height
          : (moveEvent.clientX - rect.left) / rect.width;
      options.onRatioChanged(Math.min(1 - minRatio, Math.max(minRatio, raw)));
    };

    const onUp = (): void => {
      splitter.classList.remove('cm-splitter--dragging');
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
    };

    // Bewusst am Fenster statt am Splitter mit `setPointerCapture`: die
    // Zeigererfassung geht verloren, sobald sich der Inhalt unter dem Zeiger
    // neu aufbaut (die Views zeichnen im Sekundentakt), und der Zug bleibt
    // dann mitten in der Bewegung stehen.
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
  });

  return splitter;
}
